export class Limit {
  private limit: number;

  constructor(limit: number) {
    this.limit = limit;
  }
}
